import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './pages/home.jsx';

import 'antd/dist/antd.css';

ReactDOM.render(
  <React.StrictMode>
    <Home/>
  </React.StrictMode>,
  document.getElementById('root')
);

